import { ContentWidth, TextWidth } from '@ta-interaktiv/react-disco-grid'
import { Diary_DE, Diary_FR } from 'components/Localization/Diary'
import { Impressum_DE, Impressum_FR } from 'components/Localization/Impressum'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import ArrowLeft from './icn_arrow_left.svg'
import ArrowRight from './icn_arrow_right.svg'

export const Diary = ({
  lang = 'de',
  colorMode = 'light',
}: {
  lang?: 'de' | 'fr'
  colorMode?: 'light' | 'dark' | undefined
}) => {
  const [currentEntry, setCurrentEntry] = useState(0)

  let Locales: { title: string; entries: [string, string, string[]][] } =
    lang === 'fr' ? Diary_FR : Diary_DE
  return (
    <StyledDiary colorMode={colorMode}>
      <TextWidth>
        <h4>{Locales.title}</h4>
        <DateDisplay>
          <button
            disabled={currentEntry === 0}
            onClick={() =>
              setCurrentEntry(currentEntry > 0 ? currentEntry - 1 : 0)
            }
          >
            <img src={ArrowLeft} className='arrow left' />
          </button>
          <Title>{Locales.entries[currentEntry][0]}</Title>
          <button
            disabled={currentEntry === Locales.entries.length - 1}
            onClick={() =>
              setCurrentEntry(
                currentEntry < Locales.entries.length - 1
                  ? currentEntry + 1
                  : Locales.entries.length - 1
              )
            }
          >
            <img src={ArrowRight} className='arrow right' />
          </button>
        </DateDisplay>
      </TextWidth>
      <ContentWidth>
        <ImageContainer>
          {(Locales.entries[currentEntry][2] as string[]).map((m) => (
            <img src={m} />
          ))}
        </ImageContainer>
      </ContentWidth>

      <TextWidth>
        <TextDisplay>{Locales.entries[currentEntry][1]}</TextDisplay>
      </TextWidth>
    </StyledDiary>
  )
}

const Title = styled.div`
  line-height: 1.3em;
  @media only screen and (max-width: 700px) {
    font-size: 15px;
  }
`
const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 30px;
  margin-top: 30px;
  gap: 15px;

  img {
    max-width: calc(50% - 15px);
    @media only screen and (min-width: 1600px) {
      max-width: calc(25% - 15px);
    }
  }
`
const StyledDiary = styled.div<{ colorMode: 'light' | 'dark' | undefined }>`
  width: calc(100%);
  background-color: var(--blue-main);
  color: #fff;
  padding: 30px;
  padding-left: 0;
  padding-right: 0;
  display: flex;
  flex-direction: column;
  h4 {
    line-height: 1.3em;
    margin: 0;
    margin-bottom: 15px;
    padding: 0;
    font-weight: 300;
    font-size: 18px;
    letter-spacing: 0.2px;
    text-align: center;
  }

  img.arrow {
    background-color: var(--brandblue-main);
    &.left {
      margin-right: 15px;
    }
    &.right {
      margin-left: 15px;
    }
  }
`
const DateDisplay = styled.div`
  font-size: 26px;
  width: 100%;
  font-weight: 700;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  button {
    padding: 0;
    border: 0;
    background-color: transparent;
    &:disabled {
      opacity: 0.2;
    }
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  div {
    flex: 0 0 calc(100% - 110px);
    text-align: center;
  }
`
const TextDisplay = styled.div`
  font-size: 18px;
  letter-spacing: 0.2px;
  line-height: 1.5em;
  margin-bottom: 30px;
`
